module.exports = __webpack_public_path__ + "img/mamalous_qr_menu.e96c73be.png";